export function formatSniProfileBirthday (value) {
  const match = String(value || '').trim().match(/^\d{4}-\d{2}-\d{2}/)
  return match ? `${match[0]} 00:00:00` : ''
}
